var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosshairYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.94 14C23.7135 11.9721 22.8042 10.0815 21.3613 8.63869C19.9185 7.19585 18.0279 6.28651 16 6.06V5C16 4.45 15.55 4 15 4C14.45 4 14 4.45 14 5V6.06C11.9721 6.28651 10.0815 7.19585 8.63869 8.63869C7.19585 10.0815 6.28651 11.9721 6.06 14H5C4.45 14 4 14.45 4 15C4 15.55 4.45 16 5 16H6.06C6.28651 18.0279 7.19585 19.9185 8.63869 21.3613C10.0815 22.8042 11.9721 23.7135 14 23.94V25C14 25.55 14.45 26 15 26C15.55 26 16 25.55 16 25V23.94C18.0279 23.7135 19.9185 22.8042 21.3613 21.3613C22.8042 19.9185 23.7135 18.0279 23.94 16H25C25.55 16 26 15.55 26 15C26 14.45 25.55 14 25 14H23.94ZM15 22C11.13 22 8 18.87 8 15C8 11.13 11.13 8 15 8C18.87 8 22 11.13 22 15C22 18.87 18.87 22 15 22Z",
    fill: "#ffbe00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4,
    fill: "#ffbe00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairYellow);
export default __webpack_public_path__ + "static/media/crosshair--yellow.ea7e76fba293f37a96b0739bdb945f9b.svg";
export { ForwardRef as ReactComponent };